module.exports = __webpack_public_path__ + "85bb72377ac0cbe1107cf4e60fe8ee46.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-78@2x.png
// module id = 537
// module chunks = 0